export default __webpack_public_path__ + "static/media/NoImage.f79bb804.png";